const FOREIGN_TAX_RESIDENCES = new Set(['china', 'cina', 'clr', 'cn', 'peoples republic of china', 'prc']);

function normalizeTaxResidence(value: string): string {
  return value.trim().normalize('NFD').replaceAll(/\p{M}/gu, '').toLowerCase().replaceAll(/\s+/g, ' ');
}

export function isForeignTaxResidence(value: string): boolean {
  const normalized = normalizeTaxResidence(value);
  if (!normalized) {
    return false;
  }
  return FOREIGN_TAX_RESIDENCES.has(normalized);
}

export function isDomesticTaxResidence(value: string): boolean {
  return !isForeignTaxResidence(value);
}

export function isValidForeignIdentifier(value: string): boolean {
  return /^[A-Z0-9]{6,20}$/i.test(value.replaceAll(/\s/g, ''));
}
